import React, { useState } from 'react';

function App() {
  const [weight, setWeight] = useState('');
  const [height, setHeight] = useState('');
  const [bmi, setBmi] = useState(null);
  const [message, setMessage] = useState('');

  const calculateBmi = () => {
    const w = parseFloat(weight);
    const h = parseFloat(height) / 100;
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) {
      setMessage('Пожалуйста, введите корректные положительные значения');
      setBmi(null);
      return;
    }
    const bmiValue = w / (h * h);
    setBmi(bmiValue.toFixed(2));

    if (bmiValue < 18.5) {
      setMessage('Недостаток массы тела');
    } else if (bmiValue < 24.9) {
      setMessage('Нормальный вес');
    } else if (bmiValue < 29.9) {
      setMessage('Избыточный вес');
    } else {
      setMessage('Ожирение');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
      <h2>Калькулятор индекса массы тела (ИМТ)</h2>
      <div>
        <label>Вес (кг):</label><br />
        <input
          type="number"
          value={weight}
          onChange={e => setWeight(e.target.value)}
          placeholder="Введите вес"
        />
      </div>
      <div>
        <label>Рост (см):</label><br />
        <input
          type="number"
          value={height}
          onChange={e => setHeight(e.target.value)}
          placeholder="Введите рост"
        />
      </div>
      <button onClick={calculateBmi} style={{ marginTop: 10 }}>
        Рассчитать ИМТ
      </button>
      {bmi && (
        <div style={{ marginTop: 20 }}>
          <h3>Ваш ИМТ: {bmi}</h3>
          <p>{message}</p>
        </div>
      )}
      {!bmi && message && (
        <p style={{ color: 'red', marginTop: 20 }}>{message}</p>
      )}
    </div>
  );
}

export default App;
